import { VApp } from 'vuetify/lib/components/VApp';
import { VMain } from 'vuetify/lib/components/VMain';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c(VApp,[(_vm.authenticated)?_c('side-nav',{attrs:{"mini_variant":_vm.mini_variant}}):_vm._e(),(_vm.authenticated)?_c('top-nav',{on:{"toggle_mini_variant":function($event){_vm.mini_variant = !_vm.mini_variant}}}):_vm._e(),_c('loading'),_c('notification'),_c(VMain,[_c('router-view')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }